// 'use strict';
export const ResponseStatus = {
  0: 'Success',
  1: 'Failed',
  2: 'Error'
};
export const GenderType = {
  0: 'None',
  120000000: 'Male',
  120000001: 'Female'
};
export const RegistrationStatus = {
  0: 'None',
  120000000: 'UnRegistered',
  120000001: 'RegistrationCodeSend',
  120000002: 'Registered'
};
export const ActivityStatus = {
  0: 'None',
  120000000: 'Open',
  120000001: 'Completed',
  120000002: 'Skipped'
};
export const ActivityType = {
  0: 'None',
  120000000: 'Email',
  120000001: 'HTMLMessage',
  120000002: 'Notification',
  120000003: 'PhoneCall',
  120000004: 'SimpleQuery',
  120000005: 'SMS',
  120000006: 'Survey',
  120000007: 'PatientQuery',
  120000008: 'BookAppointment',
  120000009: 'UploadDocument'
};
export const ActivitySource = {
  0: 'None',
  120000000: 'Broadcast',
  120000001: 'CareManager',
  120000002: 'Chat',
  120000003: 'EngagementRule',
  120000004: 'HealthAlert',
  120000005: 'Program'
};
export const PatientLoginStatus = {
  0: 'Success',
  1: 'Failed',
  2: 'Error',
  3: 'ConfirmationRequired',
  4: 'AccountLocked',
  5: 'RegistrationPending'
};


export const QuestionType = {
  120000000: 'SingleChoice',
  120000001: 'MultiChoice',
  120000002: 'Text',
  120000003: 'MultipleText'
};
export const ColumnDataType = {
  0: 'None',
  120000000: 'text',
  120000001: 'number',
  120000002: 'date',
  120000003: 'textarea',
  120000004: 'Slider'
};
export const ConditionType = {
  120000000: 'Logical',
  120000001: 'Compare'
};

export const ConditionOperator = {
  120000000: 'And',
  120000001: 'Or'
};

export const CompareOperator = {
  120000000: 'Equal',
  120000001: 'NotEqual'
};
export const AuthType = {
  120000000: 'AD',
  120000001: 'PASSWORDLESS'
};
export const RewardType = {
  0: 'None',
  120000000: 'NoReward',
  120000001: 'EventCheckIn',
  120000002: 'SessionCheckIn',
  120000003: 'SurveyCompleted',
  120000004: 'AppointmentCompleted',
  120000005: 'VASBenefit',
  120000006: 'MobileUsage',
  120000007: 'DoctorVisit'
};
export const RewardPointStatus = {
  0: 'None',
  120000000: 'Reward',
  120000001: 'Redeem'
};
